import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import * as PathUI from "../ui/PathUI"
import TeachPathItemControls from "./TeachPathItemControls"
import TeachPathResource from "./TeachPathResource"
import TeachPathStep from "./TeachPathStep"

const TeachPathLesson = ({ pathItem }) => {
  return (
    <PathUI.PathLessonContainer>
      <PathUI.PathLessonHeader>
        <Text.H4 inverted>{pathItem.name}</Text.H4>
        <Text.Meta inverted>{pathItem.description}</Text.Meta>
      </PathUI.PathLessonHeader>
      <TeachPathItemControls pathItem={pathItem} inverted />
      <PathUI.PathLessonGrid>
        {pathItem.items.map((pathItem) => (
          <li key={pathItem.id}>
            {pathItem.type === "resource" ? (
              <TeachPathResource pathItem={pathItem} layout="grid" />
            ) : pathItem.type === "step" ? (
              <TeachPathStep pathItem={pathItem} />
            ) : null}
          </li>
        ))}
      </PathUI.PathLessonGrid>
    </PathUI.PathLessonContainer>
  )
}

TeachPathLesson.displayName = "TeachPathLesson"

TeachPathLesson.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default TeachPathLesson
